import { useMemo } from "react";
import { useWindowSize as useWindowSizeFromReactUse } from "react-use";

export const useWindowSize = () => {
	const { width, height } = useWindowSizeFromReactUse();

	const isLaptop = useMemo(() => width >= 1024, [width]);

	return { width, height, isLaptop };
};
